import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import Cookies from "universal-cookie";
import { ADD_BUS, POST_PDT, REQ_PDT, ADMIN_ADD_USER_URL } from "../../constants/url";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination,
  Modal, Grid, TextField, Box, Fade, Button,
} from "@mui/material";
import { API as url1 } from "../../config";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { FaRegCheckSquare, FaRegSquare } from "react-icons/fa";
import { getBTypes } from "../../actions/businessProfileAction";
import { Tooltip } from "react-tooltip";
import {
  CUSTOMER_PATH, ENABLE_OFFER_PATH, ADMIN_SELL_PRODUCT_ADD_PATH, UPDATE_EMAIL_URL, ADMIN_ADD_BUSINESS_PROFILE_PATH,
  ADMIN_REQUEST_PRODUCT_ADD_PATH, ADD_COINS_PATH, BLOCK_USER_PATH, UNBLOCK_USER_PATH, SEARCH_CUSTOMER
} from "../../constants/url";
import {
  ERR_GETTING, ERR_POSTING, ERROR, ERR, CONFIRM, SUCC_ALERT_TITLE, SUCC_ADD_CUS,
  ERR_ALERT_TITLE, CONFIRM_BLOCK_CUS, CONFIRM_TITLE, CONFIRM_UNBLOCK_CUS
} from "../../constants/alertMessage";
import { privateApiCall } from "../../api/privateApi";

const cookies = new Cookies();
const Customer = () => {
  const localRole = JSON.parse(localStorage.getItem("role"))
  const permissions = localRole && localRole.permissions ? localRole.permissions : "All"
  const [showModal, setShowModal] = useState(false);
  const [customer, setCustomer] = useState({
    namee: "",
    email: "",
    country_code:"+91",
    mobile: "",
    error: "",
    header: "Add Customer",
    succes: false,
    crops: [],
    message: "",
    imageName: "",
    type_id: "",
    type: "add",
    image: "",
    remove: false,
  });

  const {
    namee,
    mobile,
    email,
    country_code
  } = customer;

  const [values, setValues] = useState({
    data: [],
    success: false,
    removed: false,
    img1: "",
    img2: "",
    img3: "",
    img4: "",
    keywords: "",
    title: "",
    description: "",
    qty: "",
    price: "",
    unit: "Kg",
    location: "",
    latitude: "",
    longitude: "",
    expdate: "",
    availableDate: "",
    auction_status: 0,
    organic_status: 1,
    safe_status: 0,
    transpot_status: 0,
    chargesAfter: "",
    freeDelivery: "",
    startDate: "",
    endDate: "",
  });

  const [profile, setProfile] = useState({
    bimg1: "",
    bimg2: "",
    bimg3: "",
    bimg4: "",
    selectedBtype: "",
    bType: [],
    cName: "",
    bDescription: "",
    contactPerson: "",
    contactNumber: "",
    address: "",
    serviceCharge: "",
    bLatitude: "",
    bLongitude: "",
    bDeliveryAvailable: "",
    bChargesAfter: "",
    bFreeDelivery: "",
  });

  const {
    serviceCharge,
    bimg1,
    bimg2,
    bimg3,
    bimg4,
    selectedBtype,
    bType,
    cName,
    bDescription,
    contactPerson,
    contactNumber,
    address,

    bDeliveryAvailable,
    bChargesAfter,
    bFreeDelivery,
  } = profile;

  const [request, setRequest] = useState({
    rimg1: "",
    rstartDate: "",
    rendDate: "",
    rlocation: "",
    rLatitude: "",
    rLongitude: "",
    runit: "Kg",
    rprice: "",
    rqty: "",
    rtitle: "",
    rkeywords: "",
    rdescription: "",
  });

  const {
    rimg1,
    rstartDate,
    rendDate,
    rlocation,
    runit,
    rprice,
    rqty,
    rtitle,
    rkeywords,
    rdescription,
  } = request;

  const {
    startDate,
    endDate,
    data,
    img1,
    img2,
    img3,
    img4,
    keywords,
    title,
    description,
    qty,
    price,
    unit,
    location,
    expdate,
    availableDate,
    auction_status,
    organic_status,
    transpot_status,
    safe_status,
    freeDelivery,
    chargesAfter,
  } = values;

  const [image1, setImage1] = useState("");
  const [image2, setImage2] = useState("");
  const [image3, setImage3] = useState("");
  const [image4, setImage4] = useState("");

  const [bimage1, setbImage1] = useState("");
  const [bimage2, setbImage2] = useState("");
  const [bimage3, setbImage3] = useState("");
  const [bimage4, setbImage4] = useState("");

  const [rimage, setrImage] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

const [isSubmitting, setIsSubmitting] = useState(false);
const [isPostSubmitting, setIsPostSubmitting] = useState(false);
const [isBusinessSubmitting, setIsBusinessSubmitting] = useState(false);
const [isRequestSubmitting, setIsRequestSubmitting] = useState(false);

  const handleCustomerChange = (name) => (e) => {
    setCustomer({ ...customer, error: false, [name]: e.target.value });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true); 
    const requestUrl = `${ADMIN_ADD_USER_URL}?mobile_no=${mobile}&refCode=&name=${namee}&email=${email}&country_code=${encodeURIComponent(country_code)}`
    privateApiCall(requestUrl, "GET")
      .then(
        (res) => {
          setIsSubmitting(false);
          if (res.data.status) {
            handleCloseModal();
            Swal.fire({
              title: `${SUCC_ALERT_TITLE}`,
              text: `${SUCC_ADD_CUS}`,
              icon: "success",
              confirmButtonText: "Ok",
              showCancelButton: false,
            }).then(() => {
              loadData();
            });
          } else {
            handleCloseModal();
            Swal.fire({
              title: res.data.message,
              text: "",
              icon: "error",
              confirmButtonText: "Ok",
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
              }
            });
          }
        },
        (err) => {
          handleCloseModal();
          setIsSubmitting(false);
          Swal.fire({
            title: `${ERR_POSTING}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      );
  };

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleRowPageChange = (e) => {
    setRowsPerPage(+e.target.value);
    setPage(0);
  };

  const agritech_token = cookies.get("agritech_token");
  useEffect(() => {
    loadData();
  }, []);

  const handleShowModal = () => setShowModal(true);
  const navigate = useNavigate();
  const handleCloseModal = () => {
    setCustomer({
      ...customer,
      namee: "",
      email: "",
      mobile: "",
      country_code:"",
    })
    setShowModal(false);
  };

  const loadData = () => {
    const requestUrl = `${CUSTOMER_PATH}?token=${cookies.get("agritech_token")}&startDate=${startDate}&endDate=${endDate}`
    privateApiCall(requestUrl, "GET")
      .then(
        (res) => {
          const k = 1;
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].sno = k + +i;
          }
          setValues({ ...values, data: res.data });
        },
        (err) => {
          Swal.fire({
            title: `${ERR_ALERT_TITLE}`,
            text: `${ERR_GETTING}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      )
      .catch(() => {
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          text: `${ERR_GETTING}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      });

    getBTypes(agritech_token).then((data) => {
      if (data.error) {
        Swal.fire({
          title: data.error,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      } else {
        setProfile({ ...profile, bType: data.types });
      }
    });
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;

    try {
      const requestUrl = `${SEARCH_CUSTOMER}?&query=${searchValue}`
      const response = await privateApiCall(requestUrl, 'GET')

      if (response.data && response.data.length) {
        setValues((prevState) => ({
          ...prevState,
          data: response.data,
        }));
        setPage(0);
      } else {
        setValues((prevState) => ({
          ...prevState,
          data: [],
        }));
      }
    } catch (error) {
      Swal.fire({
        title: `${ERROR}`,
        text: `${error.message}`,
        icon: `${ERR}`,
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: `${CONFIRM}`,
      });
    }
  };

  const loadData1 = (type, value) => {
    const requestUrl = `${CUSTOMER_PATH}?token=${cookies.get("agritech_token")}&startDate=${type === 'start' ? value : startDate}&endDate=${type === 'end' ? value : endDate}`;
  
    privateApiCall(requestUrl, 'GET')
      .then(response => {
        const data = response.data.map((item, index) => ({
          ...item,
          sno: index + 1,
        }));
  
        if (type === "start") {
          setValues({ ...values, data, startDate: value });
        } else {
          setValues({ ...values, data, endDate: value });
        }
      })
      .catch(err => {
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          text: `${ERR_GETTING}`,
          icon: `${ERR}`,
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: `${CONFIRM}`,
        });
      });
  };

  const onFileChange1 = (e) => {
    setValues({
      ...values,
      error: false,
      img1: URL.createObjectURL(e.target.files[0]),
    });
    setImage1(e.target.files[0]);
  };

  const onFileChange2 = (e) => {
    setValues({
      ...values,
      error: false,
      img2: URL.createObjectURL(e.target.files[0]),
    });
    setImage2(e.target.files[0]);
  };

  const onFileChange3 = (e) => {
    setValues({
      ...values,
      error: false,
      img3: URL.createObjectURL(e.target.files[0]),
    });
    setImage3(e.target.files[0]);
  };

  const onFileChange4 = (e) => {
    setValues({
      ...values,
      error: false,
      img4: URL.createObjectURL(e.target.files[0]),
    });
    setImage4(e.target.files[0]);
  };

  const requestFileChange = (e) => {
    setRequest({
      ...request,
      rimg1: URL.createObjectURL(e.target.files[0]),
    });
    setrImage(e.target.files[0]);
  };

  const bChange = (name) => (e) => {
    if (name === "b1") {
      setProfile({
        ...profile,
        bimg1: URL.createObjectURL(e.target.files[0]),
      });
      setbImage1(e.target.files[0]);
    } else if (name === "b2") {
      setProfile({
        ...profile,
        bimg2: URL.createObjectURL(e.target.files[0]),
      });
      setbImage2(e.target.files[0]);
    } else if (name === "b3") {
      setProfile({
        ...profile,
        bimg3: URL.createObjectURL(e.target.files[0]),
      });
      setbImage3(e.target.files[0]);
    } else {
      setProfile({
        ...profile,
        bimg4: URL.createObjectURL(e.target.files[0]),
      });
      setbImage4(e.target.files[0]);
    }
  };

  const handleChange = (name) => (e) => {
    if (name === "startDate") {
      loadData1("start", e.target.value);
    } else {
      loadData1("end", e.target.value);
    }
  };

  const offer = (row, index) => {
    const handleChange = (status) => (e) => {
      Swal.fire({
        title:
          status === 1 ? `Enable Offer ${row.name}` : `Remove Offer ${row.name}`,
        text: "",
        icon: "question",
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          const requestUrl = `${ENABLE_OFFER_PATH}?token=${cookies.get("agritech_token")}&offer_status=${status}&mobile_no=${row.mobile_no}`
          privateApiCall(requestUrl, "GET")


            .then((res) => {
              if (res.status === 200) {
                var selections = data;
                selections[index].offer_status = status;

                setValues({ ...values, data: selections });
              }
            })
            .catch(() => {
              Swal.fire({
                title: `~${ERR_ALERT_TITLE}`,
                icon: "error",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "OK",
              });
            })
        }
      })
        .catch(() => {
          Swal.fire({
            title: `${ERR_GETTING}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        })
    };

    if (row.offer_status && row.offer_status === 1) {
      return (
        <div>
          <i>
            <FaRegCheckSquare
              color="#769A0F"
              onClick={handleChange(0)}
              size="15"
            />
          </i>
        </div>
      );
    } else {
      return (
        <div>
          <i>
            <FaRegSquare color="#98a6ad" onClick={handleChange(1)} size="15" />
          </i>
        </div>
      );
    }
  };

  const create = (row) => {
    const handleChange = (name) => (e) => {
      setValues({ ...values, error: false, [name]: e.target.value });
    };
    const handleCheckBoxChange = (name, type) => (e) => {
      setValues({ ...values, [name]: type });
    };

    const createPost = (e) => {
      e.preventDefault();
      if (isPostSubmitting) return;
      setIsPostSubmitting(true);
      const chapter = {};
      e.persist();
      const formData = new FormData();
      const jwtToken = cookies.get("jwtToken"); // Get JWT token

      formData.append("image1", image1);
      formData.append("image2", image2);
      formData.append("image3", image3);
      formData.append("image4", image4);
      formData.append("mobile_no", row.mobile_no);
      formData.append("title", title);
      formData.append("description", description);
      formData.append("keywords", keywords);
      formData.append("qty", qty);
      formData.append("price", price);
      formData.append("location", location);
      formData.append("unit", unit);
      formData.append("latitude", row.latitude);
      formData.append("longitude", row.longitude);
      formData.append("expDate", expdate);
      formData.append("availableDate", availableDate);
      formData.append("auction_status", auction_status);
      formData.append("organic_status", organic_status);
      formData.append("safe_status", safe_status);
      formData.append("transpot_status", transpot_status);
      formData.append("chargesAfter", chargesAfter);
      formData.append("freeDelivery", freeDelivery);
      const requestUrl = `${ADMIN_SELL_PRODUCT_ADD_PATH}`
      privateApiCall(requestUrl, "POST", formData)
        .then((res) => {
          setIsPostSubmitting(false);
          if (!res.data.status) {
            Swal.fire({
              title: res.data.msg,
              text: "",
              icon: "error",
              confirmButtonText: "Ok",
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
              }
            });
          } else {
            Swal.fire({
              title: res.data.msg,
              text: "",
              icon: "success",
              confirmButtonText: "Ok",
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
                setValues({
                  ...values,
                  img1: "",
                  img2: "",
                  img3: "",
                  img4: "",
                  keywords: "",
                  title: "",
                  description: "",
                  qty: "",
                  price: "",
                  unit: "Kg",
                  location: "",
                  latitude: "",
                  longitude: "",
                  expdate: "",
                  availableDate: "",
                  auction_status: 0,
                  organic_status: 1,
                  safe_status: 0,
                  transpot_status: 0,
                  chargesAfter: "",
                  freeDelivery: "",
                });
                setImage1("");
                setImage2("");
                setImage3("");
                setImage4("");
            const modalElement = document.getElementById(`post${row._id}`);
            if (modalElement) {
              modalElement.classList.remove("show");
              modalElement.style.display = "none";
              modalElement.setAttribute("aria-hidden", "true");
              document.body.classList.remove("modal-open");
              const backdrop = document.querySelector(".modal-backdrop");
              if (backdrop) {
                backdrop.remove();
              }
            } else {
              console.error("Modal element not found for ID:", `post${row._id}`);
            }
              }
            });
          }
        });
    };

    const handleBChange = (name) => (e) => {
      setProfile({ ...profile, error: false, [name]: e.target.value });
    };
    const handleBCheckBoxChange = (name, type) => (e) => {
      setProfile({ ...profile, [name]: type });
    };
    const createBusiness = (e) => {
      e.preventDefault(); // ← ADD THIS LINE to prevent page reload
      if (isBusinessSubmitting) return; // Add this check
      setIsBusinessSubmitting(true);
      const formData = new FormData();
      formData.append("image1", bimage1);
      formData.append("image2", bimage2);
      formData.append("image3", bimage3);
      formData.append("image4", bimage4);
      formData.append("mobile_no", row.mobile_no);
      formData.append("btype", selectedBtype);
      formData.append("company_name", cName);
      formData.append("description", bDescription);
      formData.append("contact_person", contactPerson);
      formData.append("contact_number", contactNumber);
      formData.append("address", address);
      formData.append("latitude", row.latitude);
      formData.append("longitude", row.longitude);
      formData.append("expDate", expdate);
      formData.append("charges", serviceCharge);
      formData.append("deliveryAvailable", bDeliveryAvailable);
      formData.append("chargesAfter", bChargesAfter);
      formData.append("freeDelivery", bFreeDelivery);
    
      const requestUrl = `${ADMIN_ADD_BUSINESS_PROFILE_PATH}`
      privateApiCall(requestUrl, "POST", formData)
        .then((res) => {
          setIsBusinessSubmitting(false);
          if (!res.data.status) {
            Swal.fire({
              title: res.data.msg,
              text: "",
              icon: "error",
              confirmButtonText: "Ok",
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
              }
            });
          } else {
            Swal.fire({
              title: res.data.msg,
              text: "",
              icon: "success",
              confirmButtonText: "Ok",
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
                setProfile({
                  ...profile,
                  bimg1: "",
                  bimg2: "",
                  bimg3: "",
                  bimg4: "",
                  selectedBtype: "",
                  cName: "",
                  bDescription: "",
                  contactPerson: "",
                  contactNumber: "",
                  address: "",
                  serviceCharge: "",
                  bLatitude: "",
                  bLongitude: "",
                  bDeliveryAvailable: "",
                  bChargesAfter: "",
                  bFreeDelivery: "",
                });
                setbImage1("");
                setbImage2("");
                setbImage3("");
                setbImage4("");
                
                // Close the modal after success
                const modalElement = document.getElementById(`business${row._id}`);
                if (modalElement) {
                  modalElement.classList.remove("show");
                  modalElement.style.display = "none";
                  modalElement.setAttribute("aria-hidden", "true");
                  document.body.classList.remove("modal-open");
                  const backdrop = document.querySelector(".modal-backdrop");
                  if (backdrop) {
                    backdrop.remove();
                  }
                }
              }
            });
          }
        });
    };

    const handleRequestChange = (name) => (e) => {
      setRequest({ ...request, error: false, [name]: e.target.value });
    };

const requestPost = (e) => {
  e.preventDefault(); 
  if (isRequestSubmitting) return;
  setIsRequestSubmitting(true);
  
  const formData = new FormData();
  formData.append("image1", rimage);
  formData.append("mobile_no", row.mobile_no);
  formData.append("title", rtitle);
  formData.append("description", rdescription);
  formData.append("keywords", rkeywords);
  formData.append("qty", rqty);
  formData.append("price", rprice);
  formData.append("location", rlocation);
  formData.append("unit", runit);
  formData.append("latitude", row.latitude);
  formData.append("longitude", row.longitude);
  formData.append("startDate", rstartDate);
  formData.append("endDate", rendDate);
  
  const requestUrl = `${ADMIN_REQUEST_PRODUCT_ADD_PATH}`
  privateApiCall(requestUrl, "POST", formData)
    .then((res) => {
      setIsRequestSubmitting(false);
      if (!res.data.status) {
        Swal.fire({
          title: res.data.msg,
          text: "",
          icon: "error",
          confirmButtonText: "Ok",
          showCancelButton: false,
        });
      } else {
        Swal.fire({
          title: res.data.msg,
          text: "",
          icon: "success",
          confirmButtonText: "Ok",
          showCancelButton: false,
        }).then((result) => {
          if (result.isConfirmed) {
            setRequest({
              ...request,
              rimg1: "",
              rkeywords: "",
              rtitle: "",
              rdescription: "",
              rqty: "",
              rprice: "",
              runit: "Kg",
              rlocation: "",
              rlatitude: "",
              rlongitude: "",
              rstartDate: "",
              rendDate: "",
            });
            setrImage("");
            
            const fileInput = document.querySelector(`#request${row._id} input[type="file"]`);
            if (fileInput) {
              fileInput.value = ''; 
            }
            
            // Close the modal
            const modalElement = document.getElementById(`request${row._id}`);
            if (modalElement) {
              modalElement.classList.remove('show');
              modalElement.style.display = 'none';
              document.body.classList.remove('modal-open');
              modalElement.setAttribute('aria-hidden', 'true');
              const backdrop = document.querySelector('.modal-backdrop');
              if (backdrop) {
                backdrop.remove();
              }
            }
          }
        });
      }
    });
};

    const deleteCus = (e) => {
      if (row && row.block_status === 0 || row && row.delete_status==="active") {
        return (
          <span>
            {permissions.some(item => item.keyword === "profilesCustomers" && item.isUnblock == true) &&
              <button
                type="submit"
                // className="btn btn-icon waves-effect waves-light btn-success "
                alt="Block"
                data-toggle="modal"
                data-target={"#myModal" + row._id}
                style={{ width: '30px', height: '30px', padding: '5px !important' }}             >
                {" "}
                <i className="fas fa-thumbs-up" style={{ fontSize: '14px' }}></i>{" "}
              </button>
            }
            <div
              id={"myModal" + row._id}
              className="modal fade"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="myModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <form
                  method="post"
                  action={`${BLOCK_USER_PATH}/${row._id}/?token=${cookies.get(
                    "agritech_token"
                  )}`}
                >
                  <a href="#" title="Approve" data-toggle="tooltip">
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-hidden="true"
                        >
                          ×
                        </button>
                        <h5 className="modal-title" id="myModalLabel">
                          Warning!
                        </h5>
                      </div>
                      <div className="modal-body">
                        Are you sure want to Block this customer?
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary waves-effect"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary waves-effect waves-light"
                        >
                          Block
                        </button>
                      </div>
                    </div>
                  </a>
                </form>
              </div>
            </div>
          </span>
        );
      } else if  (row && (row.block_status === 1 || row.delete_status === "inactive")) {
        return (
          <span>
            {permissions.some(item => item.keyword === "profilesCustomers" && item.isBlock == true) &&
              <button
                type="submit"
                className="btn btn-icon waves-effect waves-light btn-danger"
                data-toggle="modal"
                alt="Unblock"
                data-target={"#myModal" + row._id}
              >
                {" "}
                <i className="fas fa-thumbs-down"></i>{" "}
              </button>
            }
            <div
              id={"myModal" + row._id}
              className="modal fade"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="myModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <form role="form">
                  <a href="#" data-toggle="tooltip">
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-hidden="true"
                        >
                          ×
                        </button>
                        <h5 className="modal-title" id="myModalLabel">
                          Warning!
                        </h5>
                      </div>
                      <div className="modal-body">
                        <div className="row"></div>
                        Are you sure want to unblock this customer?
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary waves-effect"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary waves-effect waves-light"
                        >
                          Unblock
                        </button>
                      </div>
                    </div>
                  </a>
                </form>
              </div>
            </div>
          </span>
        );
      } else {
        return null; // Return null for rows without block_status
      }
    };

    return (
      <span>
        <div style={{ display: "flex", marginTop: "8px" }}>
          <div style={{ marginLeft: "-8px" }}>
            {permissions.some(item => item.keyword === "profilesCustomers" && item.isPostProduct == true) &&
              <>
                <img
                  className="mr-2"
                  data-toggle="modal"
                  // data-target={"#post" + row._id}
                  data-target={row ? `#post${row._id}` : ""}
                  data-tooltip-id="1"
                  data-tooltip-content={`${POST_PDT}`}
                  src="/assets/icons/post.png"
                  width="20"
                  height="20"
                  alt=""
                ></img>
                <Tooltip id="1" />
              </>
            }
          </div>
          {permissions.some(item => item.keyword === "profilesCustomers" && item.isAddBusiness == true) &&
            <div>
              <img
                className="mr-2"
                data-toggle="modal"
                data-target={"#business" + row._id}
                src="/assets/icons/business.png"
                data-tooltip-id="2"
                data-tooltip-content={`${ADD_BUS}`}
                width="17"
                height="17"
                alt=""
              ></img>
              <Tooltip id="2" />
            </div>
          }
          {permissions.some(item => item.keyword === "profilesCustomers" && item.isRequestProduct == true) &&
            <div>
              <img
                className="mr-2"
                data-toggle="modal"
                data-target={"#request" + row._id}
                src="/assets/icons/request.png"
                data-tooltip-id="3"
                data-tooltip-content={`${REQ_PDT}`}
                width="22"
                height="22"
                alt=""
              ></img>
              <Tooltip id="3" />
            </div>
          }
        </div>

        {/*  Post Product */}
        <div
          id={"post" + row._id}
          className="modal fade bs-example-modal-xl"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <form onSubmit={createPost}>
              <a href="#" title="Approve" data-toggle="tooltip">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-hidden="true"
                    >
                      ×
                    </button>
                    <h5 className="modal-title text-dark" id="myModalLabel">
                      List Product for {row.name}
                    </h5>
                  </div>
                  <div className="modal-body" style={{ maxHeight: "450px", overflowY: "auto" }}>
                    <div className="row ">
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 1
                        </div>

                        {img1 != "" ? (
                          <div>
                            <img
                              src={img1}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            onChange={onFileChange1}
                            accept="image/png,  image/jpeg"
                            className="mt-3 margin-top-10"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 2
                        </div>

                        {img2 != "" ? (
                          <div>
                            <img
                              src={img2}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={onFileChange2}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 3
                        </div>

                        {img3 != "" ? (
                          <div>
                            <img
                              src={img3}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={onFileChange3}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 4
                        </div>

                        {img4 != "" ? (
                          <div>
                            <img
                              src={img4}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={onFileChange4}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Title
                          </div>

                          <input
                            type="text"
                            className="form-control"
                            value={title}
                            placeholder="Enter Title"
                            onChange={handleChange("title")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Keywords (multiple values separated by comma)
                          </div>

                          <input
                            type="text"
                            className="form-control"
                            value={keywords}
                            placeholder="Enter Keywords"
                            onChange={handleChange("keywords")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4 ">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Unit
                          </div>

                          <select
                            id="single"
                            className="form-control"
                            value={unit}
                            onChange={handleChange("unit")}
                          >
                            {[
                              "Kg",
                              "Gram",
                              "Nos",
                              "Litre",
                              "Ml",
                              "Bottle",
                              "Packet",
                              "Tonne",
                            ].map((person, i) => (
                              <option key={i} value={person}>
                                {" "}
                                {person}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Quantity
                          </div>

                          <input
                            type="number"
                            className="form-control"
                            value={qty}
                            placeholder="Enter Quantity"
                            onChange={handleChange("qty")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Price
                          </div>

                          <input
                            type="number"
                            className="form-control"
                            value={price}
                            placeholder="Enter Price"
                            onChange={handleChange("price")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Available Date
                          </div>

                          <input
                            type="date"
                            className="form-control"
                            value={availableDate}
                            placeholder="Enter Available Date"
                            onChange={handleChange("availableDate")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Expiry Date
                          </div>

                          <input
                            type="date"
                            className="form-control"
                            value={expdate}
                            placeholder="Enter Expiry Date"
                            onChange={handleChange("expdate")}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Location
                          </div>

                          <input
                            type="text"
                            className="form-control"
                            value={location}
                            placeholder="Enter Location"
                            onChange={handleChange("location")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Description
                          </div>

                          <input
                            type="text"
                            className="form-control"
                            value={description}
                            placeholder="Enter Description"
                            onChange={handleChange("description")}
                            required
                          />
                        </div>
                      </div>
                      {/* <div className="col-md-3 ml-3 mt-2 d-flex justify-content-start ">
                        <div className="form-group">
                          {auction_status == 1 ? (
                            <i>
                              <FaRegCheckSquare
                                color="#769A0F"
                                onClick={handleCheckBoxChange(
                                  "auction_status",
                                  0
                                )}
                                size="20"
                              />
                            </i>
                          ) : (
                            <i>
                              <FaRegSquare
                                color="#98a6ad"
                                onClick={handleCheckBoxChange(
                                  "auction_status",
                                  1
                                )}
                                size="20"
                              />
                            </i>
                          )}

                          <label className="ml-2 text-dark">For Auction</label>
                        </div>
                      </div>

                      <div className="col-md-3 ml-3 mt-2 d-flex justify-content-start ">
                        <div className="form-group">
                          {organic_status == 1 ? (
                            <i>
                              <FaRegCheckSquare
                                color="#769A0F"
                                onClick={handleCheckBoxChange(
                                  "organic_status",
                                  0
                                )}
                                size="25"
                              />
                            </i>
                          ) : (
                            <i>
                              <FaRegSquare
                                color="#98a6ad"
                                onClick={handleCheckBoxChange(
                                  "organic_status",
                                  1
                                )}
                                size="25"
                              />
                            </i>
                          )}

                          <label className="ml-2 text-dark">Organic</label>
                        </div>
                      </div>
                      <div className="col-md-3 ml-3 mt-2 d-flex justify-content-start ">
                        <div className="form-group">
                          {safe_status == 1 ? (
                            <i>
                              <FaRegCheckSquare
                                color="#769A0F"
                                onClick={handleCheckBoxChange("safe_status", 0)}
                                size="25"
                              />
                            </i>
                          ) : (
                            <i>
                              <FaRegSquare
                                color="#98a6ad"
                                onClick={handleCheckBoxChange("safe_status", 1)}
                                size="25"
                              />
                            </i>
                          )}

                          <label className="ml-2 text-dark">Safe To Eat</label>
                        </div>
                      </div>
                      <div className="col-md-3 ml-3 mt-2 d-flex justify-content-start ">
                        <div className="form-group">
                          {transpot_status == 1 ? (
                            <i>
                              <FaRegCheckSquare
                                color="#769A0F"
                                onClick={handleCheckBoxChange(
                                  "transpot_status",
                                  0
                                )}
                                size="25"
                              />
                            </i>
                          ) : (
                            <i>
                              <FaRegSquare
                                color="#98a6ad"
                                onClick={handleCheckBoxChange(
                                  "transpot_status",
                                  1
                                )}
                                size="25"
                              />
                            </i>
                          )}

                          <label className="ml-2 text-dark">
                            Transport Available
                          </label>
                        </div>
                      </div>
                      {transpot_status == 1 && (
                        <>
                          <div className="col-md-4">
                            <div className="form-group">
                              <div
                                className="text-dark text-left font-size-16 mb-2 "
                                style={{ letterSpacing: "0.04rem" }}
                              >
                                Free Delivery Upto KM
                              </div>

                              <input
                                type="text"
                                className="form-control"
                                value={freeDelivery}
                                placeholder="Enter KM"
                                onChange={handleChange("freeDelivery")}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <div
                                className="text-dark text-left font-size-16 mb-2 "
                                style={{ letterSpacing: "0.04rem" }}
                              >
                                Charges after KM
                              </div>

                              <input
                                type="text"
                                className="form-control"
                                value={chargesAfter}
                                placeholder="Enter Price"
                                onChange={handleChange("chargesAfter")}
                                required
                              />
                            </div>
                          </div>
                        </>
                      )} */}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary waves-effect"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary waves-effect waves-light"
                      disabled={isPostSubmitting}
                    >
                      {isPostSubmitting ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </a>
            </form>
          </div>
        </div>

        {/*  Request Product */}
        <div
          id={"request" + row._id}
          className="modal fade bs-example-modal-xl"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <form onSubmit={requestPost}>
              <a href="#" title="Approve" data-toggle="tooltip">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-hidden="true"
                    >
                      ×
                    </button>
                    <h5 className="modal-title text-dark" id="myModalLabel">
                      Product Enquiry for {row.name}
                    </h5>
                  </div>
                  <div className="modal-body" style={{ maxHeight: "450px", overflowY: "auto" }}>
                    <div className="row ">
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 1
                        </div>

                        {rimg1 != "" ? (
                          <div>
                            <img
                              src={rimg1}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={requestFileChange}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>

                      <div className="row m-1">
                        <div className="col-md-4">
                          <div className="form-group">
                            <div
                              className="text-dark text-left font-size-16 mb-2 "
                              style={{ letterSpacing: "0.04rem" }}
                            >
                              Title
                            </div>

                            <input
                              type="text"
                              className="form-control"
                              value={rtitle}
                              placeholder="Enter Title"
                              onChange={handleRequestChange("rtitle")}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <div
                              className="text-dark text-left font-size-16 mb-2 "
                              style={{ letterSpacing: "0.04rem" }}
                            >
                              Keywords (multiple values separated by comma)
                            </div>

                            <input
                              type="text"
                              className="form-control"
                              value={rkeywords}
                              placeholder="Enter Keywords"
                              onChange={handleRequestChange("rkeywords")}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <div
                              className="text-dark text-left font-size-16 mb-2 "
                              style={{ letterSpacing: "0.04rem" }}
                            >
                              Unit
                            </div>

                            <select
                              id="single"
                              className="form-control"
                              value={runit}
                              onChange={handleRequestChange("runit")}
                            >
                              {[
                                "Kg",
                                "Gram",
                                "Nos",
                                "Litre",
                                "Ml",
                                "Bottle",
                                "Packet",
                                "Tonne",
                              ].map((person, i) => (
                                <option key={i} value={person}>
                                  {" "}
                                  {person}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <div
                              className="text-dark text-left font-size-16 mb-2 "
                              style={{ letterSpacing: "0.04rem" }}
                            >
                              Quantity
                            </div>

                            <input
                              type="number"
                              className="form-control"
                              value={rqty}
                              placeholder="Enter Quantity"
                              onChange={handleRequestChange("rqty")}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <div
                              className="text-dark text-left font-size-16 mb-2 "
                              style={{ letterSpacing: "0.04rem" }}
                            >
                              Price
                            </div>

                            <input
                              type="number"
                              className="form-control"
                              value={rprice}
                              placeholder="Enter Price"
                              onChange={handleRequestChange("rprice")}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <div
                              className="text-dark text-left font-size-16 mb-2 "
                              style={{ letterSpacing: "0.04rem" }}
                            >
                              Start Date
                            </div>

                            <input
                              type="date"
                              className="form-control"
                              value={rstartDate}
                              placeholder="Enter Available Date"
                              onChange={handleRequestChange("rstartDate")}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <div
                              className="text-dark text-left font-size-16 mb-2 "
                              style={{ letterSpacing: "0.04rem" }}
                            >
                              End Date
                            </div>

                            <input
                              type="date"
                              className="form-control"
                              value={rendDate}
                              placeholder="Enter Expiry Date"
                              onChange={handleRequestChange("rendDate")}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <div
                              className="text-dark text-left font-size-16 mb-2 "
                              style={{ letterSpacing: "0.04rem" }}
                            >
                              Location
                            </div>

                            <input
                              type="text"
                              className="form-control"
                              value={rlocation}
                              placeholder="Enter Location"
                              onChange={handleRequestChange("rlocation")}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <div
                              className="text-dark text-left font-size-16 mb-2 "
                              style={{ letterSpacing: "0.04rem" }}
                            >
                              Description
                            </div>

                            <input
                              type="text"
                              className="form-control"
                              value={rdescription}
                              placeholder="Enter Description"
                              onChange={handleRequestChange("rdescription")}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary waves-effect"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary waves-effect waves-light"
                      disabled={isRequestSubmitting} 
                    >
                      {isRequestSubmitting ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </a>
            </form>
          </div>
        </div>

        {/* Add Business Profile */}
        <div
          id={"business" + row._id}
          className="modal fade bs-example-modal-xl"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <form onSubmit={createBusiness}>
              <a href="#" title="Approve" data-toggle="tooltip">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-hidden="true"
                    >
                      ×
                    </button>
                    <h5 className="modal-title text-dark" id="myModalLabel">
                      Add Business Profile for {row.name}
                    </h5>
                  </div>
                  <div className="modal-body" style={{ maxHeight: "450px", overflowY: "auto" }}>
                    <div className="row ">
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 1
                        </div>

                        {bimg1 != "" ? (
                          <div>
                            <img
                              src={bimg1}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={bChange("b1")}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 2
                        </div>

                        {bimg2 != "" ? (
                          <div>
                            <img
                              src={bimg2}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={bChange("b2")}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 3
                        </div>

                        {bimg3 != "" ? (
                          <div>
                            <img
                              src={bimg3}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={bChange("b3")}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <div
                          className="text-dark text-left font-size-16 mb-2"
                          style={{ letterSpacing: "0.04rem" }}
                        >
                          Image 4
                        </div>

                        {bimg4 != "" ? (
                          <div>
                            <img
                              src={bimg4}
                              alt=""
                              height="150px"
                              width="100%"
                            />
                          </div>
                        ) : (
                          <img
                            src="/assets/icons/try.jpg"
                            alt=""
                            height="150px"
                            width="100%"
                            className=""
                          />
                        )}

                        <div className="mt-3">
                          <input
                            type="file"
                            id="image"
                            className="mt-3 margin-top-10"
                            onChange={bChange("b4")}
                            accept="image/png,  image/jpeg"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Company Name
                          </div>

                          <input
                            type="text"
                            className="form-control"
                            value={cName}
                            placeholder="Enter Name"
                            onChange={handleBChange("cName")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Contact Person
                          </div>

                          <input
                            type="text"
                            className="form-control"
                            value={contactPerson}
                            placeholder="Enter Contact Person"
                            onChange={handleBChange("contactPerson")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Contact Number
                          </div>

                          <input
                            type="number"
                            className="form-control"
                            value={contactNumber}
                            placeholder="Enter Contact Number"
                            onChange={handleBChange("contactNumber")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4 ">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Business Type
                          </div>

                          <select
                            id="single"
                            className="form-control"
                            value={selectedBtype}
                            onChange={handleBChange("selectedBtype")}
                          >
                            <option value="">---Select Business Type---</option>

                            {bType.map((person, i) => (
                              <option key={i} value={person._id}>
                                {" "}
                                {person.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Service Charges
                          </div>

                          <input
                            type="number"
                            className="form-control"
                            value={serviceCharge}
                            placeholder="Enter Charges"
                            onChange={handleBChange("serviceCharge")}
                            required
                          />
                        </div>
                      </div> */}

                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Address
                          </div>

                          <input
                            type="text"
                            className="form-control"
                            value={address}
                            placeholder="Enter Address"
                            onChange={handleBChange("address")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <div
                            className="text-dark text-left font-size-16 mb-2 "
                            style={{ letterSpacing: "0.04rem" }}
                          >
                            Description
                          </div>

                          <input
                            type="text"
                            className="form-control"
                            value={bDescription}
                            placeholder="Enter Description"
                            onChange={handleBChange("bDescription")}
                            required
                          />
                        </div>
                      </div>

                      {/* <div className="col-md-3 ml-3 mt-2 d-flex justify-content-start ">
                        <div className="form-group">
                          {bDeliveryAvailable == 1 ? (
                            <i>
                              <FaRegCheckSquare
                                color="#769A0F"
                                onClick={handleBCheckBoxChange(
                                  "bDeliveryAvailable",
                                  0
                                )}
                                size="25"
                              />
                            </i>
                          ) : (
                            <i>
                              <FaRegSquare
                                color="#98a6ad"
                                onClick={handleBCheckBoxChange(
                                  "bDeliveryAvailable",
                                  1
                                )}
                                size="25"
                              />
                            </i>
                          )}

                          <label className="ml-2 text-dark">
                            Delivery Available
                          </label>
                        </div>
                      </div>
                      {bDeliveryAvailable == 1 && (
                        <>
                          <div className="col-md-4">
                            <div className="form-group">
                              <div
                                className="text-dark text-left font-size-16 mb-2 "
                                style={{ letterSpacing: "0.04rem" }}
                              >
                                Free Delivery Upto KM
                              </div>

                              <input
                                type="number"
                                className="form-control"
                                value={bFreeDelivery}
                                placeholder="Enter KM"
                                onChange={handleBChange("bFreeDelivery")}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <div
                                className="text-dark text-left font-size-16 mb-2 "
                                style={{ letterSpacing: "0.04rem" }}
                              >
                                Charges after KM
                              </div>

                              <input
                                type="number"
                                className="form-control"
                                value={bChargesAfter}
                                placeholder="Enter Charges"
                                onChange={handleBChange("bChargesAfter")}
                                required
                              />
                            </div>
                          </div>
                        </>
                      )} */}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary waves-effect"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary waves-effect waves-light"
                      disabled={isBusinessSubmitting}
                    >
                      {isBusinessSubmitting ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </a>
            </form>
          </div>
        </div>
      </span>
    );
  };

  const deleteCus = (row) => {
    const handleBlock = (event, url) => {
      event.preventDefault();
      Swal.fire({
        title: `${CONFIRM_TITLE}`,
        text: `${CONFIRM_BLOCK_CUS}`,
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "Block",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          privateApiCall(url, "POST", {})

            .then((response) => {
              console.log(response, "response..........");
              if (response.status === 200) {
                Swal.fire(
                  "Blocked!",
                  "The customer has been blocked.",
                  "success"
                )
                loadData()

              } else {
                console.error("API call failed");
                Swal.fire("Error!", "Failed to block the customer.", "error");
              }
            })
            .catch((error) => {
              console.error("Error:", error);
              Swal.fire("Error!", "Failed to block the customer.", "error");
            });
        }
      });
    };

    const handleUnblock = (event, url) => {
      event.preventDefault();
      Swal.fire({
        title: `${CONFIRM_TITLE}`,
        text: `${CONFIRM_UNBLOCK_CUS}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Unblock",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          privateApiCall(url, "POST", {})

            .then((response) => {
              if (response.status === 200) {
                Swal.fire(
                  "Unblocked!",
                  "The customer has been unblocked.",
                  "success"
                );
                loadData()
              } else {
                Swal.fire("Error!", "Failed to unblock the customer.", "error");
              }
            })
            .catch((error) => {
              console.error("Error:", error);
              Swal.fire("Error!", "Failed to unblock the customer.", "error");
            });
        }
      });
    };

    if (row && row.block_status === 0 && row.delete_status !== "inactive") {
      return (
        <span>
          {permissions.some(item => item.keyword === "profilesCustomers" && item.isBlock == true) &&
            <>
              <button
                type="button"
                className="btn btn-icon waves-effect  waves-light btn-danger"
                alt="Block"
                data-tooltip-id="8"
                data-tooltip-content={`Block`}
                data-toggle="modal"
                data-target={"#myModal" + row._id}
                onClick={(event) =>
                  handleBlock(
                    event,
                    `${BLOCK_USER_PATH}/${row._id}/?token=${cookies.get(
                      "agritech_token"
                    )}`
                  )
                }
                style={{
                  width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px', paddingRight: '5px', marginTop: '10px'
                }}          >
                {" "}
                <i className="fas fa-thumbs-down" style={{ fontSize: '8px', marginBottom: '0px' }}></i>{" "}
              </button>
              <Tooltip id="8" />
            </>
          }
        </span>
      );
    } else if (row && row.block_status === 1 || row && row.delete_status === "inactive") {
      return (
        <span>
          {permissions.some(item => item.keyword === "profilesCustomers" && item.isUnblock == true) &&
            <>
              <button
                type="button"
                className="btn btn-icon waves-effect   waves-light btn-success"
                data-toggle="modal"
                alt="Unblock"
                data-tooltip-id="7"
                data-tooltip-content={`Unblock`}
                data-target={"#myModal" + row._id}
                onClick={(event) =>
                  handleUnblock(
                    event,
                    `${UNBLOCK_USER_PATH}/${row._id}/?token=${cookies.get(
                      "agritech_token"
                    )}`
                  )
                }
                style={{
                  width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '9px', paddingLeft: '5px', paddingRight: '5px', marginTop: '10px'
                }}
              >
                {" "}
                <i
                  className="fas fa-thumbs-up"
                  style={{ fontSize: '8px', marginBottom: '0px' }}
                ></i>{" "}
              </button>
              <Tooltip id="7" />
            </>
          }
        </span>
      );
    } else {
      return null;
    }
  };

  const regexp = /^[0-9\b]+$/;
  const emailRegexp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // validator function pass the user input value and should return true|false.
  function jobNameValidator(value) {
    const response = {
      isValid: true,
      notification: { type: "success", msg: "", title: "" },
    };
    if (!value) {
      response.isValid = false;
      response.notification.type = "error";
      response.notification.msg = "Value must be inserted";
      response.notification.title = "Requested Value";
    } else if (!regexp.test(value)) {
      response.isValid = false;
      response.notification.type = "error";
      response.notification.msg = "Value must be number";
      response.notification.title = "Invalid Value";
    }

    return response;
  }

  function jobEmailValidator(value) {
    const response = {
      isValid: true,
      notification: { type: "success", msg: "", title: "" },
    };
    if (!value) {
      response.isValid = false;
      response.notification.type = "error";
      response.notification.msg = "Not valid value";
      response.notification.title = "Requested Value";
    } else if (!emailRegexp.test(value)) {
      response.isValid = false;
      response.notification.type = "error";
      response.notification.msg = "Not valid email id";
      response.notification.title = "Invalid Value";
    }

    return response;
  }

  function confirmCell(row, cellName, cellValue, confirm, done) {
    setTimeout(() => {
      if (confirm("Do you want to accept this change?")) {
        console.log("value" + row._id);
        console.log("cellName" + cellName);
        if (cellName == "email") {
          updateEmail(row._id, row.email);
        } else {
          updateCell(row._id, row.coins);
        }
        //  done(); // contine to save the changes
        // updateCell(row,column);
      } else {
        done(false); // reject the changes
      }
    }, 0);
    return { async: false };
  }

  function updateCell(id, coins) {
    const requestUrl = `${ADD_COINS_PATH}?token=${cookies.get("agritech_token")}&_id=${id}&coins=${coins}`
    privateApiCall(requestUrl, 'GET').then(
      (res) => {
        console.log(res.status);
        if (res.status === 200) {
          //  location.reload(false);
        } else {
          // Handle other status codes if needed
        }
      },
      (err) => {
        Swal.fire({
          title: `${err}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      }
    );
  }

  function updateEmail(id, email) {
    const requestUrl = `${UPDATE_EMAIL_URL}?token=${cookies.get("agritech_token")}&_id=${id}&email=${email}`
    privateApiCall(requestUrl, "GET")

      .then(
        (res) => {
          console.log(res.status);
          if (res.status == 200) {
            //  location.reload(false);
          } else {
          }
        },
        (err) => {
          Swal.fire({
            title: `${err}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      );
  }

  const cellEditProp = {
    mode: "click",
    beforeSaveCell: confirmCell,
  };

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#769A0F" />
      <Sidebar type="profiles" />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        {" "}
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Customers</li>
                    </ol>
                  </div>
                  <h4 className="page-title">Customers</h4>
                </div>
              </div>
            </div>
            <div className="card-box">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-2 mt-3i">

                    {permissions.some(item => item.keyword === "profilesCustomers" && item.isCreate == true) &&
                      <button className="btn btn-icon waves-effect waves-light btn-primary mb-3" onClick={handleShowModal} >
                        <i className="fa fa-user"></i> Add Customer
                      </button>
                    }
                    <Modal
                      open={showModal}
                      onClose={handleCloseModal}
                      closeAfterTransition
                      BackdropProps={{
                        style: {
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        },
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      disableBackdropClick
                    >
                      <Fade in={showModal}>
                        <Box
                          sx={{
                            bgcolor: 'background.paper',
                            boxShadow: 1,
                            p: 4,
                            borderRadius: 2,
                            width: '60%',
                            marginBottom: '50px',
                          }}
                        >
                          <h2>Add Customer</h2>
                          <form
                            onSubmit={onSubmit}
                          >
                            <Grid container spacing={2} style={{ marginTop: "20px" }}>
                              <Grid item xs={12}>
                                <TextField
                                  fullWidth
                                  label="Name"
                                  variant="outlined"
                                  name="namee"
                                  value={namee}
                                  onChange={handleCustomerChange("namee")}
                                  placeholder="Enter Name"
                                  required
                                />
                              </Grid>
                                <Grid item xs={12}>
                                <TextField
                                  fullWidth
                                  label="email"
                                  variant="outlined"
                                  name="email"
                                  value={email}
                                  onChange={handleCustomerChange("email")}
                                  placeholder="Enter Email Id"
                                  required
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <TextField
                                  fullWidth
                                  label="Country Code"
                                  variant="outlined"
                                  name="Country Code"
                                  value={country_code}
                                  onChange={handleCustomerChange("country_code")}
                                  placeholder="Enter Country Code (eg: +91)"
                                  required
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <TextField
                                  fullWidth
                                  label="mobile no"
                                  variant="outlined"
                                  name="mobile no"
                                  value={mobile}
                                  onChange={handleCustomerChange("mobile")}
                                  placeholder="Enter mobile Number"
                                  required
                                />
                              </Grid>

                            </Grid>
                            <Grid
                              container
                              justifyContent="flex-end"
                              style={{ marginTop: "40px", marginBottom: "20px" }}
                            >
                              <Button
                                variant="outlined"
                                color="error"
                                onClick={handleCloseModal}
                                style={{ marginRight: "10px" }}
                              >
                                Close
                              </Button>
                              <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting} // Add this
                                
                                style={{ backgroundColor: "#769A0F" }}
                              >
                                  {isSubmitting ? "Submitting..." : "Submit"}
                              </Button>
                            </Grid>
                          </form>
                        </Box>
                      </Fade>
                    </Modal>

                  </div>
                  <div className="row container-fluid"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  > 
                  <div className="col-md-3 ">
                    <label>Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      style={{ marginTop: "5px" }}
                      value={startDate}
                      placeholder="Start Date"
                      onChange={handleChange("startDate")}
                      required
                    ></input>
                  </div>
                  <div className="col-md-3 ">
                    <label>End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      style={{ marginTop: "5px" }}
                      value={endDate}
                      placeholder="End Date"
                      onChange={handleChange("endDate")}
                      required
                    />
                  </div>
                  <div  style={{ position: 'relative', marginLeft: 'auto', }}>
                        <input
                          type="text"
                          placeholder="Search..."
                          className="form-control"
                          style={{ width: '200px', paddingLeft: '35px', boxSizing: 'border-box', marginLeft: "auto" }}
                          onChange={(e) => {
                            handleSearch(e);
                            if (e.target.value.trim() === '') {
                              e.target.nextElementSibling.style.display = 'inline-block';
                            } else {
                              e.target.nextElementSibling.style.display = 'none';
                            }
                          }}
                       />
                        <i
                          className="fas fa-search"
                          style={{
                            position: 'absolute',
                            left: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#aaa',
                          }}
                        ></i>
                      </div>
                  </div>
                




                </div>
              </div>

              <div style={{ width: "98%" }}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">S.No</TableCell>
                        <TableCell align="left">Name</TableCell>
                        <TableCell align="left">Email</TableCell>
                        <TableCell align="left">Mobile</TableCell>
                        {/* <TableCell align="left">Subscription</TableCell> */}
                        {/* <TableCell align="left">Validity</TableCell> */}
                        {/* <TableCell align="left">Coins</TableCell> */}
                        {/* <TableCell align="left">Language</TableCell> */}
                        {/* <TableCell align="left">Offer</TableCell> */}
                        <TableCell align="left">Status</TableCell>
                        <TableCell align="left">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => (
                          <TableRow key={row._id}>
                            <TableCell align="left">{index + 1}</TableCell>
                            <TableCell align="left" style={{ minWidth: "150px" }}>
                              {row.name}
                            </TableCell>
                            <TableCell align="left">{row.email}</TableCell>
                            <TableCell align="left">{row.country_code} {row.mobile_no}</TableCell>
                            {/* <TableCell align="left">{row.sub}</TableCell> */}
                            {/* <TableCell align="left">{row.val}</TableCell> */}
                            {/* <TableCell align="left">{row.coins}</TableCell> */}
                            {/* <TableCell align="left">{row.language}</TableCell> */}
                            {/* <TableCell align="left">{offer(row, index)}</TableCell> */}
                            <TableCell>
                              {" "}
                              {row.block_status == 0 && row.delete_status !== "inactive" ? (
                                <span className="btn-sm btn-success ">
                                  Active
                                </span>
                              ) : (
                                <span className="btn-sm btn-danger">
                                  InActive
                                </span>
                              )}{" "}
                            </TableCell>
                            <TableCell align="center">
                              <div style={{ display: "flex", justifyContent: "center" }}>
                                {create(row)}
                                {deleteCus(row)}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 50, 100]}
                  page={page}
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  component="div"
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowPageChange}
                ></TablePagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Customer;